<div class="page-detail-wrap vetro-master-bg">
    <h5>{{"test.typelbl" | translate}}</h5>
</div>
<div class="vetro-bg">
    <p-table #dt [value]="testTypeList" styleClass="p-datatable-gridlines" [globalFilterFields]="['name']"
        [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50,100]" >
        <ng-template pTemplate="caption">

            <div class="d-flex justify-content-between">
                <span class="p-input-icon-left p-ml-auto" width="300px">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)=" applyFilterGlobal($event,'contains')"
                        placeholder="Search..." />
                </span>
                <div class="d-flex table-action-wrap align-items-center">
                    <p-button type="button" icon="pi pi-plus-circle" pRipple class="btn-link mr-3" pTooltip="Add"
                        tooltipPosition="bottom" iconPos="left" (click)="addModal()"
                        label="{{'commonbtn.add'|translate}}">
                    </p-button>
                    <button class="p-button p-button-raised" type="button" icon="pi pi-check" style="width: 100px; justify-content: center;"
                        (click)="export()">
                            {{ "commonbtn.export" | translate }}
                    </button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Order Id</th>
                <th>Edit</th>
                <th>Activate</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-model>
            <tr
        [style.backgroundColor]="!model.isActive ? '#f4f4f4' : ''"
        [style.color]="!model.isActive ? '#888' : ''"
        [style.opacity]="!model.isActive ? '0.6' : '1'"
            >
                <td>{{model.id}}</td>
                <td>{{model.name}}</td>
                <td>{{model.sortOrder}}</td>
                <td> <a class="pi pi-pencil" style="color:#fddc88; text-align:center;" (click)="edit(model)"></a>
                </td>
                <td>
          <p-inputSwitch
            [style]="{ marginLeft: '1rem' }"
            [(ngModel)]="model.isActive"
            (onChange)="onToggleStatus(model)"
          >
          </p-inputSwitch>
        </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Add Item Dialogue Modal -->
<!-- <p-dialog [(visible)]="showModal" [style]="{width: '800px' , height:'800px'}" [header]="modalTitle" [modal]="true"
    styleClass="p-fluid" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="content">
        <div class="row">
            <div class="col-md-12 mt-2 mb-2">
                <label for="name" style="font-size: medium;">{{"common.
                    |translate}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="model.name" required />
            </div>
            </div>
            <div class="row">
            <div class="col-md-6">
                <label for="name" style="font-size: medium;">Standard</label>
                <p-multiSelect 
 [resetFilterOnHide]="true" #standard="ngModel" [options]="standardList" [(ngModel)]="model.standard"
                    optionLabel="name" defaultLabel="Select" optionLabel="name" optionValue="id" [required]="true"
                    name="standard" display="chip">
                </p-multiSelect>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'commonbtn.cancel'|translate}}" icon="pi pi-times" class="btn-cancle"
            (click)="showModal=false"></button>
        <button pButton pRipple label="{{'commonbtn.save'|translate}}" icon="pi pi-check" styleClass="btn-save"
            (click)="save(model)"></button>
    </ng-template>
</p-dialog> -->
<!-- End Region : Add Item Modal -->